import React from 'react'
import PropTypes from 'prop-types'
import AddDomainButton from './AddDomainButton'

/**
 * A react component that controls when to display the Add Domain functionality
 */
const AddDomainControl = (props) => (
	props.visible
		?
		<div className="AddDomainControl">
			{React.Children.map(props.children, (child) => React.cloneElement(child, {click: props.click}))}
		</div>
		:
		null
)

AddDomainControl.propTypes = {
	visible: PropTypes.bool.isRequired,
	click: PropTypes.func.isRequired,
	children: PropTypes.element.isRequired
}

AddDomainControl.defaultProps = {
	children: <AddDomainButton text='Add Domain'/>
}

export default AddDomainControl


// WEBPACK FOOTER //
// ./src/components/AddDomainControl/AddDomainControl.js